export default {
  init() {
    // only use scrolling effect on md and larger screen sizes
    if (window.innerWidth <= 767) return;

    // get all home loan program items
    // oh hey, used this here (and not querySelector) too
    const homeLoanProgramItems = document.getElementsByClassName(
      'home-loan-program-item'
    );

    // set up the intersection observer for each item
    const homeLoanProgramItemObserver = new IntersectionObserver(entries => {
      entries.forEach((entry, i) => {
        // is iitem on screen?
        if (entry.intersectionRatio > 0) {
          // if item is already visible, do nothing
          if (entry.target.classList.contains('in-view')) {
            // do nothing
            return;
            // otherwise make it visible, staggered by its position in the number of items there are
          } else {
            setTimeout(function() {
              entry.target.classList.add('in-view');
            }, i * 100);
          }
        }
      });
    });

    // each item gets an intersection observer attached to it
    // homeLoanProgramItems is an HTMLCollection, no native forEach method
    [].forEach.call(homeLoanProgramItems, function(item) {
      homeLoanProgramItemObserver.observe(item);
    });
  },
  finalize() {
    // fix for Edge SVG icons - aren't sized properly based on 100% width
    // for some reason if the stuff above in init() is moved to finalize() during development mode, Edge will size icons properly...but not when compiled for production, use this fix to ensure it works
    const isEdge =
      window.navigator.userAgent.indexOf('Edge') > -1 ? true : false;

    if (isEdge) {
      const svgIcons = document.querySelectorAll('.home-loan-program-item svg');

      [].forEach.call(svgIcons, icon => (icon.style.height = '12rem'));
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/homeLoanOptions.js